// @flow

import React from 'react';
import {
  Button,
  CircularProgress,
  makeStyles,
  Tooltip,
  Typography,
} from '@material-ui/core';

import type {Theme} from '@material-ui/core';
import {colors} from '../../../../../../../assets/styles/colors';
type Props = {
  name: string,
  selected: boolean,
  admin?: boolean,
  count?: number,
  loading?: boolean,
  showName?: boolean,
  onClick: () => void,
  icon?: React$Node,
  collapsedContent?: React$Node,
};

const useStyles = props =>
  makeStyles((theme: Theme) => ({
    filter: {
      minWidth: 44,
      textTransform: 'none',
      padding: '.25rem',
      display: 'flex',
      alignItems: 'center',
      justifyContent: props.showName ? 'space-between' : 'center',
      borderRadius: 10,
      backgroundColor: props.selected ? '#F4F4F6' : undefined,
      gap: theme.spacing(0.5),
    },
    filterLabel: {
      display: 'flex',
      alignItems: 'center',
      gap: theme.spacing(1),
      minWidth: 0,
      overflow: 'hidden',
    },
    filterName: {
      color: colors.grey700,
      fontSize: 14,
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
    },
    count: {
      backgroundColor: !props.selected ? '#F4F4F6' : undefined,
      padding: '.25rem .5rem',
      borderRadius: 12,
      flexShrink: 0,
    },
    countText: {
      color: colors.grey800,
      fontSize: 14,
      fontWeight: 500,
    },
    tooltip: {
      background: colors.grey700,
      boxShadow: '0px 4px 12px rgba(14, 21, 58, 0.08)',
      borderRadius: '4px',
      padding: '.5rem .75rem',
      color: 'white',
      fontSize: '.85rem',
      fontWeight: 500,
    },
    arrow: {
      color: colors.grey700,
    },
  }));

export default function ChatFilter(props: Props) {
  const {
    name,
    selected,
    loading,
    count,
    onClick,
    showName = true,
    icon = null,
    collapsedContent = null,
  } = props;
  const classes = useStyles({selected, showName})();

  return (
    <Tooltip
      title={name}
      arrow
      placement="right"
      disableFocusListener={showName}
      disableHoverListener={showName}
      disableTouchListener={showName}
      classes={{
        tooltip: classes.tooltip,
        arrow: classes.arrow,
      }}
    >
      <Button className={classes.filter} onClick={onClick}>
        {showName ? (
          <div className={classes.filterLabel}>
            {icon}
            <Typography className={classes.filterName}>{name}</Typography>
          </div>
        ) : (
          icon || collapsedContent
        )}
        {typeof count === 'number' && (
          <div className={classes.count}>
            {loading ? (
              <CircularProgress size={16} />
            ) : (
              <Typography className={classes.countText}>
                {count > 999 ? '999+' : count}
              </Typography>
            )}
          </div>
        )}
      </Button>
    </Tooltip>
  );
}
